/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateCart201ResponseAllOfData } from './CreateCart201ResponseAllOfData';
import {
    CreateCart201ResponseAllOfDataFromJSON,
    CreateCart201ResponseAllOfDataFromJSONTyped,
    CreateCart201ResponseAllOfDataToJSON,
} from './CreateCart201ResponseAllOfData';

/**
 * 
 * @export
 * @interface CreateCart201Response
 */
export interface CreateCart201Response {
    /**
     * 
     * @type {CreateCart201ResponseAllOfData}
     * @memberof CreateCart201Response
     */
    data: CreateCart201ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof CreateCart201Response
     */
    meta: object;
}

/**
 * Check if a given object implements the CreateCart201Response interface.
 */
export function instanceOfCreateCart201Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function CreateCart201ResponseFromJSON(json: any): CreateCart201Response {
    return CreateCart201ResponseFromJSONTyped(json, false);
}

export function CreateCart201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCart201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': CreateCart201ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function CreateCart201ResponseToJSON(value?: CreateCart201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CreateCart201ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

